var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile-header__background-wrapper",class:{ __empty: !_vm.src, __blurred: _vm.blurred },style:({ backgroundImage: ("url(" + (_vm.src ? _vm.src : '/img/empty-profile-bg.png') + ")") })})}
var staticRenderFns = []

export { render, staticRenderFns }